import { Component, HostBinding, inject, ChangeDetectionStrategy } from '@angular/core';
import { Toast, ToastActions, ToastState } from '@app/_store';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';
import { NgbToast } from '@ng-bootstrap/ng-bootstrap/toast';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgIf, NgFor, NgbToast, AsyncPipe],
})
export class ToastContainerComponent {
  @HostBinding('class')
  class = 'ngb-toasts';

  autohide = true;

  toasts$: Observable<Toast[]> = inject(Store).select(ToastState.toasts);

  constructor(public store: Store) {}

  remove(toast: Toast): Observable<void> {
    return this.store.dispatch(new ToastActions.Remove(toast));
  }
}
